import { IOrganisation, IOrganisationUser } from "../../common/models";
import { createDefaultILoadableArray, ILoadableArray, ILoadableWrapper } from "../../common/models/loadable";

export const SELECTED_SENSOR_KEY: string = "selectedCamera"

export interface AccountState  {
    organisations: ILoadableArray<ILoadableWrapper<IOrganisation>>
    users: Record<string, ILoadableArray<ILoadableWrapper<IOrganisationUser>>>
    currentOrganisation: string | undefined
}

export const initialAccountState: AccountState = {
    organisations: createDefaultILoadableArray(),
    users: {},
    currentOrganisation: undefined
}
